module.exports = __webpack_public_path__ + "img/SE_youth_from_Parkland.d9846d11.jpg";